import "./PayoffMatrixPriceIncrementComponent.scss";
import template from "./PayoffMatrixPriceIncrementComponent.html";
import {IComponentOptions} from "angular";
import {ComponentCallback} from "../../../../../../types/AngularJS";

export const PriceIncrement = "tfPayoffMatrixPriceIncrement";

export function priceIncrement(): IComponentOptions {
    return {
        template,
        bindings: {
            current: "<",
            onChange: "&"
        },
        controllerAs: "ctrl",
        controller: PayoffMatrixPriceIncrementComponentController
    };
}

export class PayoffMatrixPriceIncrementComponentController {

    /** @input */
    public readonly current: number;

    /** @output */
    public readonly onChange: ComponentCallback;

    public readonly presets = [1, 2, 3, 4, 5];

    public inputChanged(value: number | null) {
        if ((value == null) || (value < 0)) {
            this.onChange({increment: 1});
        } else {
            this.onChange({increment: value});
        }
    }
}
